// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vFct_","right":"styles_right__1O3yQ"};